<template>
    <section id="propertySchedulePanel" :class="{'rentals-schedule': dpp.isRentals}">
        <div class="grid xs-grid-cols-1 dpp-schedule">
            <div class="text-bold f4">
                <span v-if="assignedAgent && assignedAgent.firstName">Tour this home with your agent, {{ assignedAgent.firstName }}</span>
                <span v-else-if="dpp.houseRealStatus==='ACTIVE'">Tour this home with a top agent</span>
                <span v-else-if="dpp.isRentals">{{molang('dpp.propertySchedule.tourThisPropertyWithAddress', {streetAddress: dpp.geo.address})}}</span>
                <span v-else>Tour similar homes with a top agent</span>
            </div>
            <div class="dpp-schedule-photo">
                <img loading="lazy" :title="dpp.geo.formatAddress" :alt="dpp.geo.formatAddress" :src= "dpp.tnImgPath" v-if="dpp.photoCount > 0">
                <mvtMapStatic class="img" :cacheFirst="true" :lat="dpp.geo.lat" :lng="dpp.geo.lng" type="streetview" streetViewDefautType="satellite" :address="dpp.geo.formatAddress" :height="staticMapData.height" v-else></mvtMapStatic>
            </div>

            <mvtCalendar v-model="data" :icon="dpp.propertyTypeIcon"></mvtCalendar>
            <mvtTextbox  v-if="glb.agent.id && !glb.rentals">
                <div class="textarea">
                    <label>Comment</label>
                    <textarea name="comment" v-model="data.comment" maxlength="4000"></textarea>
                </div>
            </mvtTextbox>
            <div class="agent-contact flex"  @click="openHotlead(dpp.houseRealStatus==='ACTIVE' ? molang('dpp.hotButton.requestThisTime') : 'Send Request')">
                <img v-if="assignedAgent && assignedAgent.photoUrl" :title="assignedAgent.fullName"  alt="Agent Avatar" :src="assignedAgent.photoUrl" />
                <a class="btn primary regular w-100" role="button">
                    <span v-if="assignedAgent && assignedAgent.firstName">Request to tour with {{ assignedAgent.firstName }}</span>
                    <span v-else>{{molang('dpp.hotButton.requestThisTime')}}</span>
                </a>
            </div>
            <div v-if="!assignedAgent" class="dpp-schedule-footer flex left middle">
                <i class="circle bg-white icon-logo-m-new"/>
                <div class="f7 text-gray">
                    {{molang('dpp.propertySchedule.connectLocalAgent')}}
                </div>
            </div>
            <div class="paragraph f7"  v-if="showNotSupportedByMLS()">
                {{molang('dpp.propertySchedule.notMls')}}
            </div>
        </div>
    </section>
</template>
<script src="./dpp-schedule.js"></script>

<style lang="scss">
@use './dpp-schedule.scss' as *;
</style>
